import React from 'react';

import { Date, Money } from '../../components';
import OrderStatus from '../../components/order/Status';
import { getBaseCurrency } from "../../core/currency";

export function ListingRow({ item: listing }) {
  return (
    <>
      <tr className="desktop">
        <td>{listing.product?.brand?.name}</td>
        <td>{listing.product?.model?.name}</td>
        <td>{listing.product?.reference_number}</td>
        <td><Money amount={listing.price} currency={listing.currency ?? getBaseCurrency()} /></td>
        <td className="capitalize">{listing.status}</td>
        <td><Date date={listing.created_at} /></td>
      </tr>

      <tr className="mobile">
        <td>
          <div className="row p-15">
            <div className="col-12 mt-2">
              <strong>
                {listing.product?.brand?.name}&nbsp;
                {listing.product?.model?.name}
              </strong>
              <br />
              {listing.product?.reference_number}
            </div>
            <div className="col-12 mt-2">Listing Price: <strong><Money amount={listing.price} currency={listing.currency ?? getBaseCurrency()} /></strong></div>
            <div className="col-12 mt-2">Status: <strong className="capitalize">{listing.status}</strong></div>
            <div className="col-12">Date: <strong><Date date={listing.created_at} /></strong></div>
          </div>
        </td>
      </tr>
    </>
  );
}

